import { render, staticRenderFns } from "./CreateModelItem.vue?vue&type=template&id=6f6f8f78&scoped=true&"
import script from "./CreateModelItem.vue?vue&type=script&lang=js&"
export * from "./CreateModelItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6f8f78",
  null
  
)

export default component.exports